import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Char from './Char';


//https://react-slick.neostack.com/docs/api#useTransform

export const Panel = (props) => {
    const { items } = props;

      const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        swipeToSlide:true,
        slidesToShow: 8,
        touchThreshold:30,
        initialSlide: 0,
        useTransform:false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 7,
              slidesToScroll: 3,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 2,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }
        ]
      };
      
    return (
        <div id="panel" className="panel" >
          <Slider {...settings}>
            {items?.map((item)=>(
              <Char key={item.id} item={item} targetKey="boardArea" />
            ))}
          </Slider>
        </div>
    )
}

export default Panel;
